import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Chart.css'
import {Doughnut} from 'react-chartjs'
import format from '../../helpers/format'
// import {Row, Col} from 'react-flexbox-grid'

const chartOptions = {
  animation: false,
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  // animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  // tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
  tooltipTemplate: '<%=label %>',
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>",
}

@CSSModules(Styles)
export default class Chart extends Component {
  static propTypes = {
    currency: PropTypes.string.isRequired,
    invested: PropTypes.number.isRequired,
    chartData: PropTypes.array.isRequired,
    chartMessage: PropTypes.string
  }
  constructor(props){
    super(props)
  }

  render() {
    const chartData = this.props.chartData
    const invested = this.props.invested
    const currency = this.props.currency
    const chartMessage = this.props.chartMessage || 'in weapon investments'

    return (
      <div styleName='chart'>

        <Doughnut
          data={chartData}
          options={chartOptions}
          width='300'
          height='300'
        />

        <div styleName='chart-details'>
          <div styleName='chart-assets'>
            { format.money(invested,true,currency) }
          </div>
          <div>{chartMessage}</div>
        </div>

      </div>
    )
  }
}

